import { message as $message } from 'antd'
import { hasBindStoreApi } from '@/services/distributeOrder'

export const fetchHasBindShopCount = async () => {
    let { success, data, message } = await hasBindStoreApi({
        enabled: true,
        sessionStatus: 2,
        excludeShopSetList: '商家自有商城,线下店铺',
    })

    if (!success) {
        $message.error(message)
        return
    }
    return data
}
